import { render, staticRenderFns } from "./OrderModelFits.vue?vue&type=template&id=16095fc6&"
import script from "./OrderModelFits.vue?vue&type=script&lang=js&"
export * from "./OrderModelFits.vue?vue&type=script&lang=js&"
import style0 from "./OrderModelFits.vue?vue&type=style&index=0&id=16095fc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports